import ArrowBack from '@mui/icons-material/ArrowBack';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function ArrowBackIcon(props: FixMe) {
  return <ArrowBack {...props} />;
}

export default ArrowBackIcon;
